function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#B1B1B1",
  d: "M253.1,415.7h4.2l2.1,6.7h0l2.2-6.7h4.1v10.1h-2.6l0-7.7h0l-2.6,7.7h-2.5l-2.4-7.7h0l0.1,7.7h-2.6V415.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B1B1B1",
  d: "M268.2,415.7h7.1v1.9h-4.4v2.1h4.2v1.9h-4.2v2.3h4.6v1.9h-7.2V415.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B1B1B1",
  d: "M286.8,425.4c-1.7,0.4-3,0.5-3.9,0.5c-2.7,0-5.8-1.4-5.8-5.2c0-3.8,2.7-5.2,6.4-5.2c0.7,0,2.1,0.1,3,0.4 l-0.2,2.2c-0.8-0.5-1.8-0.6-2.4-0.6c-2.2,0-4,0.9-4,3.3c0,2,1.4,3.2,3.4,3.2c0.4,0,0.7-0.1,1-0.2v-2h-1.6v-1.9h4.2V425.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B1B1B1",
  d: "M292,415.7h3.3l3.9,10.1h-2.9l-0.8-2.1h-3.8l-0.8,2.1h-2.7L292,415.7z M293.7,417.7L293.7,417.7l-1.3,3.9 h2.5L293.7,417.7z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M302.2,418.1c0.1-0.4,0.2-0.8,0.2-1c0-0.8-0.4-0.8-1.1-0.8h-0.6l0.2-0.6h1.4c1.3,0,2.6,0,3.8-0.3l-0.7,2.5 h0c0.7-1.2,2-2.5,4-2.5c1.3,0,2.1,1.2,2,2.3h0c0.7-1.3,2.2-2.3,3.7-2.3c1.4,0,2.2,1,2.2,2.3c0,0.7-0.3,1.6-0.4,1.8l-1.3,4.1 c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.2,0.6,0.5,0.6c0.7,0,1.3-1.4,1.5-2.1h0.7c-0.6,1.8-1.4,3.2-3.5,3.2c-1.4,0-2.3-1.1-2.3-2.4 c0-0.5,0.2-1.3,0.3-1.8l1-3.4c0.1-0.2,0.1-0.5,0.1-0.7c0-0.3-0.1-0.6-0.6-0.6c-1.6,0-2.4,2.4-2.7,3.6l-1.4,5H306l1.9-6.6 c0.1-0.4,0.3-1,0.3-1.3c0-0.4-0.2-0.7-0.7-0.7c-1.2,0-2.1,1.9-2.5,3.3l-1.6,5.3h-3.2L302.2,418.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M331.2,415.7l-2.2,7.8c-0.1,0.2-0.1,0.5-0.1,0.8s0.1,0.5,0.5,0.5c0.8,0,1.4-1.5,1.6-2.2h0.6 c-0.4,1.6-1.5,3.3-3.5,3.3c-1.5,0-2.2-0.8-2.2-2.3l0,0c-0.8,1.3-1.7,2.3-3.3,2.3c-2.2,0-2.9-1.9-2.9-3.8c0-3,2-6.8,5.4-6.8 c1.3,0,2.3,0.7,2.5,2h0l0.5-1.7H331.2z M326.9,418.2c0-0.7-0.2-1.8-1.1-1.8c-2.2,0-3.2,6.2-3.2,6.9c0,0.7,0.1,1.4,0.9,1.4 C325.7,424.7,326.9,419.9,326.9,418.2z"
}));

var SvgMegamaLogo = function SvgMegamaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "248 408.4 86.5 25",
    enableBackground: "new 248 408.4 86.5 25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMegamaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/megama_logo.505edb2d.svg";
export { ForwardRef as ReactComponent };